module.exports = __webpack_public_path__ + "assets/img/bg-goods.40f336fe.png";